import ReducerUtils from "../../../utils/ReducerUtils"
import Actions from "../../../model/constant/actions"

const Budgets = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_BUDGETS_STATISTICS] : (_,action)=>action.status
})

export default Budgets
